/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";

import { Stack, Typography } from "@mui/material";
import { Select, SelectOption } from "components/forms";

interface ITableToolbarProps {
  groupByOptions: SelectOption[];
  monthlyViewGroupBy: string;
  setMonthlyViewGroupBy: (value: string) => void;
  monthlyViewReportBy: "deal" | "year";
  setMonthlyViewReportBy: (value: "deal" | "year") => void;
}

export const HedgeTableToolbar: React.FC<ITableToolbarProps> = ({
  groupByOptions,
  monthlyViewGroupBy,
  setMonthlyViewGroupBy,
  monthlyViewReportBy,
  setMonthlyViewReportBy
}) => {
  return (
    <Stack direction="row" sx={{ gap: "10px", alignItems: "center" }}>
      <Typography sx={{ fontWeight: 400, fontSize: "15px", color: "#071F35" }}>Row By:</Typography>
      <Select
        variant="outlined"
        sx={{
          width: 100,
          borderRadius: "8px",
          ".MuiSelect-select": {
            p: "8px"
          }
        }}
        items={groupByOptions}
        disableUnderline
        label=""
        value={monthlyViewGroupBy}
        onChange={(e) => setMonthlyViewGroupBy(e.target.value as typeof monthlyViewGroupBy)}
      />
      <Typography sx={{ fontWeight: 400, fontSize: "15px", color: "#071F35" }}>Report By:</Typography>
      <Select
        variant="outlined"
        sx={{
          width: 100,
          borderRadius: "8px",
          ".MuiSelect-select": {
            p: "8px"
          }
        }}
        items={[
          { key: "deal", text: "Asset", value: "deal" },
          { key: "year", text: "Year", value: "year" }
        ]}
        disableUnderline
        label=""
        value={monthlyViewReportBy}
        onChange={(e) => setMonthlyViewReportBy(e.target.value as typeof monthlyViewReportBy)}
      />
    </Stack>
  );
};
